import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaEnvelope, FaLayerGroup } from 'react-icons/fa';
import './ContactSticky.css';

const ContactSticky = () => {
  const { pathname } = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const isHome = pathname === '/';

  return (
    <div className="contact-sticky published_height">
      <motion.div
        className="contact-sticky-icon position-relative analytics-cta-label-class"
        role="button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        whileTap={{ scale: 0.95 }}
        aria-label={isHome ? 'Explore our product' : 'Contact us'}
        initial={{ width: '60px' }}
        animate={{ width: isHovered ? (isHome ? '240px' : '140px') : '60px' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        {isHome ? (
          <Link
            to="/case-studies"
            className="d-flex align-items-center justify-content-center gap-2 text-white text-decoration-none"
            style={{ width: '100%', height: '100%' }}
          >
            <span className="contact-icon">
              <FaLayerGroup />
            </span>
            <motion.span
              className="contact-text"
              initial={{ opacity: 0, width: 0 }}
              animate={{
                opacity: isHovered ? 1 : 0,
                width: isHovered ? 'auto' : 0
              }}
              transition={{ duration: 0.3 }}
            >
              Explore our product
            </motion.span>
          </Link>
        ) : (
          <Link
            to="/contact"
            className="d-flex align-items-center justify-content-center gap-2 text-white text-decoration-none"
            style={{ width: '100%', height: '100%' }}
          >
            <span className="contact-icon">
              <FaEnvelope />
            </span>
            <motion.span
              className="contact-text"
              initial={{ opacity: 0, width: 0 }}
              animate={{
                opacity: isHovered ? 1 : 0,
                width: isHovered ? 'auto' : 0
              }}
              transition={{ duration: 0.3 }}
            >
              Contact
            </motion.span>
          </Link>
        )}
      </motion.div>
      <span className="visually-hidden">Press Enter to open an overlay</span>
    </div>
  );
};

export default ContactSticky;
